class StickyBuyBar extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = this.querySelector('[data-sticky-qty-input]');
    this.addButton = this.querySelector('[data-sticky-add-to-cart]');
    this.quantityId = this.dataset.quantityId;
    this.submitId = this.dataset.submitId;

    if (this.addButton) {
      this.addButton.addEventListener('click', this.onAddToCart.bind(this));
    }

    // Botón principal de la página: "Comprar ahora" si existe, si no "Agregar al carrito"
    const submit = document.getElementById(this.submitId);
    const form = submit ? submit.closest('.product-form__buttons') : null;
    this.buyNowButton = form ? form.querySelector('.js-buy-now-button') : null;
    this.trigger = this.buyNowButton || submit;

    // Scroll + rAF en vez de IntersectionObserver: un salto de ancla (p. ej. a reseñas)
    // pasa el botón sin cruzar el viewport y el observer no se enteraría
    if (this.trigger) {
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
  }

  connectedCallback() {
    // Al cambiar de variante, copiar precio y estado del botón desde el HTML nuevo de la sección
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const fresh = data && data.html ? data.html.querySelector('sticky-buy-bar') : null;
      if (!fresh) return;
      const price = this.querySelector('.sticky-buy-bar__price');
      const freshPrice = fresh.querySelector('.sticky-buy-bar__price');
      if (price && freshPrice) price.innerHTML = freshPrice.innerHTML;
      const freshButton = fresh.querySelector('[data-sticky-add-to-cart]');
      if (this.addButton && freshButton) {
        this.addButton.disabled = freshButton.disabled || !data.variant;
        this.addButton.textContent = freshButton.textContent;
      }
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  update() {
    const scrolledPast = this.trigger.getBoundingClientRect().bottom < 0;
    if (scrolledPast === this.visible) return;
    this.visible = scrolledPast;
    this.classList.toggle('sticky-buy-bar--visible', scrolledPast);
    document.body.classList.toggle('has-sticky-buy-bar', scrolledPast);
  }

  onAddToCart(event) {
    event.preventDefault();
    if (this.addButton.disabled) return;

    const realQuantityInput = document.getElementById(this.quantityId);
    if (realQuantityInput && this.quantityInput) {
      realQuantityInput.value = this.quantityInput.value;
      realQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const realButton = this.buyNowButton || document.getElementById(this.submitId);
    if (realButton && !realButton.disabled) {
      realButton.click();
    }
  }
}

customElements.define('sticky-buy-bar', StickyBuyBar);
